import { env } from "~/env"

export default env.NEXT_PUBLIC_NODE_ENV === "development"
